import { groupedTopKWithFractionalIndex } from "./groupedTopKWithFractionalIndex.js";
import { consolidate } from "./consolidate.js";
function groupedOrderByWithFractionalIndex(valueExtractor, options) {
  const limit = options.limit ?? Infinity;
  const offset = options.offset ?? 0;
  const setSizeCallback = options.setSizeCallback;
  const setWindowFn = options.setWindowFn;
  const groupKeyFn = options.groupKeyFn;
  const comparator = options.comparator ?? ((a, b) => {
    if (a === b) return 0;
    if (a < b) return -1;
    return 1;
  });
  return (stream) => {
    return stream.pipe(
      groupedTopKWithFractionalIndex(
        (a, b) => comparator(valueExtractor(a), valueExtractor(b)),
        {
          limit,
          offset,
          setSizeCallback,
          setWindowFn,
          groupKeyFn
        }
      ),
      consolidate()
    );
  };
}
export {
  groupedOrderByWithFractionalIndex
};
//# sourceMappingURL=groupedOrderBy.js.map
